import { render, staticRenderFns } from "./epidemicStatistics.vue?vue&type=template&id=6f87b1f5&scoped=true&"
import script from "./epidemicStatistics.vue?vue&type=script&lang=js&"
export * from "./epidemicStatistics.vue?vue&type=script&lang=js&"
import style0 from "./epidemicStatistics.vue?vue&type=style&index=0&id=6f87b1f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f87b1f5",
  null
  
)

export default component.exports